<template>
  <div v-if="legalPage && legalPageId">
    <div class="grid grid-cols-8 bg-blue-sense px-4 lg:grid-cols-16 lg:px-0">
      <div class="col-span-8 lg:col-start-4">
        <h1 class="h2 pb-2 pt-19 text-blue-corporate lg:pb-12 lg:pt-32">
          {{ legalPage.title }}
        </h1>
      </div>
    </div>

    <div class="grid grid-cols-8 bg-white px-4 lg:grid-cols-16 lg:px-0">
      <div class="col-span-7 pb-4 pt-4 lg:col-start-4 lg:pb-8">
        <DKRichText :text="legalPage.body"></DKRichText>
      </div>
    </div>

    <div class="grid grid-cols-8 bg-white px-4 lg:grid-cols-16 lg:px-0">
      <div class="col-span-7 py-10 lg:col-start-4 lg:py-15">
        <DKButton type="secondary" @click="onGoBack">
          {{ $t('go_back.button.label') }}
        </DKButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';
import { useActiveMeta, useMeta } from 'vue-meta';
import { generateMetaInfo } from '@/helpers/metainfo';
import { DKLegalPage } from '@/models/DKLegalPage';
import { DKMetaInfo } from '@/models/DKMetaInfo';
import { FooterStatus } from '@/store/app/models/FooterStatus';
import { DKButton } from '@dormakaba/dormakaba-components';
import DKRichText from '@/components/rich-text/DKRichText.vue';

@Component({
  components: {
    DKButton,
    DKRichText,
  },
})
export default class LegalPage extends Vue {
  get metaInfo(): DKMetaInfo {
    return {
      meta: (this.$metaInfoRef as any).meta,
      page: this.legalPage,
      locale: this.$i18n.locale,
      $route: this.$route,
    };
  }

  get legalPageId(): string | null {
    return this.$store.getters['navigation/pageIdBySlug'](
      this.$route.params.slug
    );
  }

  get legalPage(): DKLegalPage {
    return this.$store.getters['content/legalPage'];
  }

  created() {
    this.$metaInfoRef = useMeta({ ...useActiveMeta() });
  }

  async mounted() {
    await this.$store.dispatch('content/fetchLegalPage', {
      id: this.legalPageId,
      locale: this.$i18n.locale,
      $route: this.$route,
      $router: this.$router,
    });

    this.$route.meta.defaultFooter = FooterStatus.FOOTER;

    const meta = generateMetaInfo(this.metaInfo);

    this.$trackView('legal_page', meta.title);

    this.$store.commit('navigation/setNavbarTransparentElement');
  }

  async serverPrefetch() {
    return Promise.all([
      this.$store.dispatch('content/fetchLegalPage', {
        id: this.legalPageId,
        locale: this.$i18n.locale,
        $route: this.$route,
        $router: this.$router,
      }),
    ]).then(() => generateMetaInfo(this.metaInfo));
  }

  onGoBack() {
    this.$router.push({ name: 'home-page' });
  }
}
</script>
